module.exports = __webpack_public_path__ + "static/whistle-top-rated-x2.c00a456d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/whistle-top-rated-x2.png
// module id = 86
// module chunks = 168707334958949